/**
 * 画面表示モード
 */
const DisplayModeCode = {
  /** 登録 */
  REGISTER: '0',
  /** 変更 */
  CHANGE: '1',
} as const;

type DisplayModeCode = typeof DisplayModeCode[keyof typeof DisplayModeCode];
export default DisplayModeCode;
